import React, { useState, useEffect } from 'react';
import styles from '../styles/albumPage.module.css';
import { useParams, Link } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import Pagination from '../components/Pagination';

export default function AlbumPage() {
    const [photos, setPhotos] = useState([]);
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const { albumId } = useParams();
    const albumName = decodeURIComponent(albumId);

    // Автоматически скролим к верху альбома при открытии альбома и смене страницы
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [currentPage]);


    // Запрашиваем на сервере информацию о фотографиях в альбоме
    useEffect(() => {
        const fetchAlbumPhotos = async () => {
            try {
                setLoading(true);
                const params = new URLSearchParams({
                    albumName: albumName,
                    x: '356',
                    y: '200',
                    pageNumber: currentPage,
                    itemsOnPage: '28'
                });

                const response = await fetch(
                    // `https://apigateway-test.nordciti.ru/v1/GLKAlbums/getAlbumPhotos?${params.toString()}`
                    `https://apigateway.nordciti.ru/v1/GLKAlbums/getAlbumPhotos?${params.toString()}`
                );

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const result = await response.json();
                setPhotos(Array.isArray(result.photos) ? result.photos : []);
                setTotalPages(result.pagesCount || 1);
                console.log('API ОТВЕТ getAlbumPhotos:', result);
            } catch (error) {
                console.error('getAlbumPhotos error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAlbumPhotos();
    }, [albumName, currentPage]);

    // Сброс страницы пагинации при смене альбома
    useEffect(() => {
        setCurrentPage(1);
    }, [albumName]);


    // Функция для смены страницы пагинации
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className={`container ${styles.albumPage}`}>
            <Link to="/#portfolio" className={styles.backLink}>← Назад к альбомам</Link>

            <h2>{albumName}</h2>

            <div className={styles.grid}>
                {loading ? (
                    <div className={styles.loaderWrapper}>
                        Загрузка фотографий . . .
                    </div>
                ) : (
                    photos?.map((photo, i) => (
                        <img
                            key={photo.name}
                            src={photo.previewImageUrl}
                            alt={photo.name}
                            loading="lazy"
                            onClick={() => {
                                setIndex(i);
                                setOpen(true);
                            }}
                        />
                    ))
                )}
            </div>

            {totalPages > 1 && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            )}


            <Link to="/#portfolio" className={styles.backLink}>К альбомам</Link>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={Array.isArray(photos)
                    ? photos.map(photo => ({ src: photo.imageUrl }))
                    : []
                }
            />
        </div>
    );
}